/**
 * Extracts Facebook browser parameters from cookies
 * @returns Object with fbp (browser ID) and fbc (click ID)
 */
export interface FacebookParams {
  fbp?: string;
  fbc?: string;
}

export function getFacebookParams(): FacebookParams {
  try {
    const cookies = document.cookie.split(';');
    const fbp = cookies.find(c => c.trim().startsWith('_fbp='))?.split('=')[1];
    const fbc = cookies.find(c => c.trim().startsWith('_fbc='))?.split('=')[1];
    
    console.log('🍪 Facebook Params:', { fbp: fbp ? 'found' : 'missing', fbc: fbc ? 'found' : 'missing' });
    
    return { fbp, fbc };
  } catch (error) {
    console.error('❌ Error extracting Facebook params:', error);
    return {};
  }
}


